//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			show: false,
		};
	},

	props: {
		title: {
			type: String,
			default: 'A different approach',
		},
		content: {
			type: String,
			default: 'BPB Auto Insight - Forecasts, culture and opinion',
		},
		arrow: {
			type: String,
			default: 'A different approach',
		},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};



// WEBPACK FOOTER //
// ./scripts/vue/PageBanner.vue